import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { FormattedCurrency } from '../../../../iwIntlProvider/FormattedCurrency';
import { Content } from '../Content';
import { DRAW_DOWN_MODE } from '../../../funding/ConfirmFundingView/ConfirmFunding.sagas';
import messages from './Loading.messages';
import styles from './Loading.module.css';
import { RootState } from '@iwProvider/configureStore';
import { TRUELAYER_REPAYMENT_TYPE } from '../../../earlyRepayment/EarlyRepaymentHelper';

const mapStateToProps = (state: RootState) => ({
    ...state.processingPaymentModal
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const Loading = ({
    senderLogo,
    receiverLogo
}: PropsFromRedux & {
    senderLogo: string;
    receiverLogo: string;
}) => {
    return (
        <Content
            title={<LoadingTitle />}
            senderLogo={senderLogo}
            receiverLogo={receiverLogo}
            icon={<span className={styles.processingDirection} />}
        />
    );
};

const LoadingTitle = connect(mapStateToProps)(({
    mode,
    amount,
    paymentMethod
}) => {
    const formattedAmount = <FormattedCurrency value={amount!} />;

    if (mode !== DRAW_DOWN_MODE) {
        if (paymentMethod === TRUELAYER_REPAYMENT_TYPE) {
            return <FormattedMessage {...messages.truelayerRepayLoading} />;
        } else
            return (
                <FormattedMessage
                    {...messages.repayLoading}
                    values={{
                        amount: formattedAmount,
                        paymentMethod: paymentMethod
                    }}
                />
            );
    }

    return (
        <FormattedMessage
            {...messages.drawDownLoading}
            values={{
                amount: formattedAmount
            }}
        />
    );
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(Loading);
